import React from "react";
import { connect } from "react-redux";

import Box from "./Box";
import Row from "./Row";
import Bool from "../../DataEntry/Bool";
import Select from "../../DataEntry/Select";

class CustomerInfo extends React.Component<any, any> {
  render() {
    const {
      customers,
      customerTypes,
      formik: { isSubmitting },
      viewOnly,
    } = this.props;

    return (
      <Box title="Customer Info">
        <Row
          label="System ID"
          name="id"
          readOnly
          className="smart-form-control smart-control-readonly"
        />
        <Row
          label="Co. Name"
          name="company"
          disabled={viewOnly || isSubmitting}
        />
        <Row
          label="Co. Name (Label)"
          name="company_label"
          disabled={viewOnly || isSubmitting}
        />
        <Row
          label="Created"
          name="created_at"
          readOnly
          className="smart-form-control smart-control-readonly"
        />
        <Row
          label="Modified"
          name="updated_at"
          readOnly
          className="smart-form-control smart-control-readonly"
        />
        <Row
          component={Select}
          label="Type"
          name="customer_type_id"
          list={customerTypes.map((i: any) => [i.id, i.name])}
          disabled={viewOnly || isSubmitting}
        />
        <Row
          component={Bool}
          label="Is Parent?"
          name="is_parent"
          disabled={viewOnly || isSubmitting}
        />
        <Row
          component={Select}
          label="Parent Co."
          name="parent_id"
          list={[""].concat(customers.map((i: any) => [i.id, i.company]))}
          disabled={viewOnly || isSubmitting}
        />
        <Row
          component={Select}
          label="Status"
          list={[
            ["true", "Active"],
            ["false", "Inactive"],
          ]}
          name="enable"
          disabled={viewOnly || isSubmitting}
        />
      </Box>
    );
  }
}

const mapStateToProps = (state: any, _props: any) => ({
  customers: state.customers.data,
  customerTypes: state.customerTypes.data,
});

const mapDispatchToProps = (_dispatch: Function) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CustomerInfo);
